<template>
  <div>
    <!-- Default white wall -->
    <default-test-wall v-if="isDefaultWall" :artwork="artwork" />

    <div v-else ref="wallContainer" v-resize="calculateArtworkScale">
      <v-img
        v-if="selectedWall"
        contain
        class="mb-0"
        :src="selectedWall.img"
        @touchmove="drag"
        @mousemove="drag"
      >
        <div
          ref="artworkImg"
          @touchstart="dragStart"
          @touchend="dragEnd"
          @mousedown="dragStart"
          @mouseup="dragEnd"
          class="dragItem"
          :style="{
            width: `${imageSize}px`,
            height: !artwork.id ? `${this.imageSize}px` : 'auto',
          }"
        >
          <v-img
            v-if="artworkImage"
            contain
            sizes="500px"
            :src="artworkImage.url"
            :srcset="artworkImage.srcset"
            :style="{ 'background-color': artwork.media.color }"
          />
        </div>
      </v-img>

      <!-- Ruler -->
      <!-- This is for testing and keep it here DONOT REMOVE -->
      <!-- 
      <div>
        <v-layout
          justify-space-around
          row
          fill-height
          style="margin-right: -40px; margin-left: -40px;"
        >
          <v-flex text-xs-center v-for="i in 11" :key="i" pa-0 :class="['ruler-' +i]">
            <span>|</span>
          </v-flex>
        </v-layout>

        <p>
          Artwork width: {{ artwork.width }}cm
          <br />
          Wall width: {{selectedWall ? selectedWall.width : NaN }}cm
        </p>
      </div> 
      -->
      <!-- /Ruler -->
    </div>

    <!-- Slider and backbutton -->
    <!-- Show slider only to user uploaded walls -->
    <v-layout v-if="!isDefaultWall" row wrap align-center mt-3>
      <v-flex grow py-0>
        <v-layout v-if="selectedWall && selectedWall.isUserWall" row ml-1>
          <v-flex ma-0 px-0 shrink>
            <v-icon class="mr-2" size="20" @click="decrementSize">fas fa-search-minus</v-icon>
          </v-flex>
          <v-flex ma-0 px-0 grow>
            <vue-slider
              tooltip="none"
              v-model="imageSize"
              :min="10"
              :max="wallWidth"
              :interval="1"
              :dotStyle="{ backgroundColor: '#4A4A4A' }"
              :processStyle="{ backgroundColor: '#4A4A4A' }"
            />
          </v-flex>
          <v-flex ma-0 px-0 shrink>
            <v-icon class="ml-2" size="20" @click="incrementSize">fas fa-search-plus</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex shrink pa-0>
        <template v-if="this.artwork.id">
          <tk-btn
            v-if="$vuetify.breakpoint.smAndDown"
            aria-label="Go back"
            small
            flat
            icon
            :to="{ path: artwork.path }"
          >
            <v-icon size="16">fas fa-chevron-left</v-icon>
          </tk-btn>
          <tk-btn v-else small flat :to="{ path: artwork.path }" aria-label="Go back">
            <v-icon left size="16">fas fa-chevron-left</v-icon>
            <span>{{ $t("COMMON.BACK") }}</span>
          </tk-btn>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { walls } from "@/config";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import DefaultTestWall from "./DefaultTestWall";

export default {
  props: {
    wallId: { required: true },
    artwork: { required: true },
  },

  components: { VueSlider, DefaultTestWall },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log("beforeRouteEnter", to.query);
      // This might be user walls. Check if there are user walls in memmory
      // Currently we storing walls only in app memory
      // So when use refreshes the  page, redirect to artwork page
      if (to.query.userWall === "1" && !vm.$app.userWalls.length) {
        console.log("Redirecto to artwork page");
        return next({ path: vm.artwork.path });
      }
    });
  },

  data() {
    return {
      dragActive: false,
      initialX: 0,
      initialY: 0,
      left: null,
      top: null,
      imageSize: 100,
      wallWidth: 737, // Initial width
    };
  },

  watch: {
    wallId: function (val) {
      console.log("WallId watch", this.selectedWall);
      // 24.09.2020 changes on zoom functionality
      // There is new request to use zoom functionality only on user uploaded walls.
      // User might have changed the image size, lets reset it
      if (this.selectedWall && !this.selectedWall.isUserWall) {
        this.calculateArtworkScale();
      }
    },
  },

  computed: {
    selectedWall() {
      console.log("SelectedWall computed", this.$route.query);

      if (this.$route.query.userWall == 1 && this.$app.userWalls.length) {
        console.log("IsUserwall", this.wallId);
        return this.$app.userWalls.find(
          (wall) => wall.id === Number(this.wallId)
        );
      }

      return walls.find((wall) => wall.id === Number(this.wallId));
    },
    isDefaultWall() {
      return this.wallId === "default";
    },

    artworkImage() {
      console.log("ARTWORK IMAGE", this.artwork.media);
      if (!this.artwork.media) return null;

      let img = this.artwork.media[0];

      if (this.$route.query.img) {
        img = this.artwork.media.find((m) => m.id === this.$route.query.img);
      }

      return img;
    },
  },

  mounted() {
    console.log("Mounted");
    const t = this.$route.query.top;
    const l = this.$route.query.left;
    // const s = this.$route.query.size;

    // if (s) this.imageSize = s;

    if (this.selectedWall && t && l) {
      this.setNewPosition(l, t);
    }
  },

  methods: {
    dragStart(e) {
      this.dragActive = true;

      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX;
        this.initialY = e.touches[0].clientY;
      } else {
        this.initialX = e.clientX;
        this.initialY = e.clientY;
      }
    },
    dragEnd(e) {
      this.dragActive = false;
      this.updateRoute();
    },
    drag(e) {
      if (!this.dragActive) return;
      e = e || window.event;
      e.preventDefault();

      let pos_x = 0;
      let pos_y = 0;

      if (e.type === "touchmove") {
        pos_x = this.initialX - e.touches[0].clientX;
        pos_y = this.initialY - e.touches[0].clientY;

        this.initialX = e.touches[0].clientX;
        this.initialY = e.touches[0].clientY;
      } else {
        // calculate the new cursor position:
        pos_x = this.initialX - e.clientX;
        pos_y = this.initialY - e.clientY;

        this.initialX = e.clientX;
        this.initialY = e.clientY;
      }

      // set the element's new position:
      const left = this.$refs.artworkImg.offsetLeft - pos_x;
      const top = this.$refs.artworkImg.offsetTop - pos_y;
      this.setNewPosition(left, top);
    },
    setNewPosition(left, top) {
      this.$refs.artworkImg.style.left = left + "px";
      this.$refs.artworkImg.style.top = top + "px";
      this.left = left;
      this.top = top;
    },
    decrementSize() {
      if (this.imageSize > 0) {
        this.imageSize = this.imageSize - 10;
      }
    },
    incrementSize() {
      if (this.imageSize < 500) {
        this.imageSize = this.imageSize + 10;
      }
    },
    updateRoute() {
      // const query = {};
      const query = { ...this.$route.query };
      if (this.left) query.left = `${this.left}`;
      if (this.top) query.top = `${this.top}`;
      if (this.$route.query.userWall) {
        query.userWall = this.$route.query.userWall;
      }

      console.log(JSON.stringify(this.$route.query), JSON.stringify(query));

      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router.replace({
          path: this.$route.path,
          query: query,
        });
      }
    },
    calculateArtworkScale() {
      // If there is no selected wall
      if (!this.$refs.wallContainer || !this.selectedWall) return;

      this.wallWidth = this.$refs.wallContainer.clientWidth; // pixel width
      const wallWidthCm = this.selectedWall.width; // in cm
      const artworkWidthCm = this.artwork.width; // in cm
      const ratio = this.wallWidth / wallWidthCm;
      const artworkWidthPx = artworkWidthCm * ratio; // in pixel

      console.log("SelectedWallWidth", this.selectedWall.width);
      console.log("Calculate artwork scale", {
        artworkWidthCm,
        ratio,
        wallWidthCm,
      });

      this.imageSize = Math.round(artworkWidthPx);
    },
  },
};
</script>

<style lang="scss" scoped>
.dragItem {
  user-select: none; // Prevets from selecting the dom
  cursor: move;
  position: absolute;
  top: 16%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;

  &.empty {
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &:hover {
    .v-image {
      opacity: 0.6;
      border: 3px dashed #444;
      box-shadow: none;
    }
  }

  .v-image {
    box-shadow: 0 0 5px 0 #000;
    pointer-events: none;
    border-radius: 2px;
  }
}
</style>
